import { useCallback, useEffect, useRef } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';

import { getWarehouseStorageConfig } from 'repositories/HttpRepository';
import { warehouseStorageConfigState } from 'atoms/WarehouseLocationSetupState';

export default function useWarehouseStorageConfig(warehouseId) {
  const [{ storageConfig, loaded }, setState] = useRecoilState(warehouseStorageConfigState);
  const reset = useResetRecoilState(warehouseStorageConfigState);
  const requestId = useRef(0);

  const reload = useCallback(() => {
    const currentRequest = ++requestId.current;
    return getWarehouseStorageConfig(warehouseId).then((res) => {
      if (currentRequest !== requestId.current) return;
      setState({ storageConfig: res.ok && res.data?.storageAreas ? res.data : null, loaded: true });
    });
  }, [warehouseId, setState]);

  useEffect(() => {
    reload();
    return () => {
      requestId.current += 1;
      reset();
    };
  }, [reload, reset]);

  return { storageConfig, loaded, reload };
}
